import { render, staticRenderFns } from "./HeaderShop.vue?vue&type=template&id=6c47cf5e&scoped=true&"
import script from "./HeaderShop.vue?vue&type=script&lang=js&"
export * from "./HeaderShop.vue?vue&type=script&lang=js&"
import style0 from "./HeaderShop.vue?vue&type=style&index=0&id=6c47cf5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c47cf5e",
  null
  
)

export default component.exports